import React, { Component } from 'react';
import { Row, Col, Modal, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

class InteractionMailModal extends Component {

    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} size="xlg">
                    <BlockUi tag="div" color="#009ef7">
                        <Modal.Header>
                            <Modal.Title>
                                {
                                    (this.props.interaction) &&
                                    <Row>
                                        <Col lg={3}>
                                            <div className={`icon ${this.props.interaction.channel.toLowerCase()}`} style={{ "left": "0px", "top": "5px" }} ></div>
                                        </Col>
                                        <Col lg={9}>
                                            <div >{this.props.interaction.groupName}</div>
                                            <div >{this.props.interaction.email}</div>
                                        </Col>
                                    </Row>
                                }
                            </Modal.Title>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("close")}
                                </Tooltip>}>
                                <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                            </OverlayTrigger>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col>
                                    <iframe title="Mail" src={this.props.url} width={"100%"} height={"720px"}></iframe>
                                </Col>
                            </Row>
                        </Modal.Body>
                    </BlockUi>
                </Modal>
            </>)
    }
}

export default withTranslation()(InteractionMailModal);